import {FilterKey, filtersConfig} from './constants'

// Sort the active filters to the left of the filters list
export const getSortedFiltersConfig = (activeFilters: Array<FilterKey>) =>
  [...filtersConfig].sort(
    (a, b) => activeFilters.indexOf(b.id) - activeFilters.indexOf(a.id)
  )
